import { format, isBefore, startOfDay, isToday, parseISO } from "date-fns";
import { ptBR } from "date-fns/locale";
import type { Tarefa } from "@/types/tarefas";

export function formatPrazo(prazo: string | null | undefined): string {
  if (!prazo) return "Sem prazo";
  try {
    return format(parseISO(prazo), "dd/MM/yyyy HH:mm", { locale: ptBR });
  } catch {
    return prazo;
  }
}

export function formatPrazoCurto(prazo: string | null | undefined): string {
  if (!prazo) return "—";
  try {
    const d = parseISO(prazo);
    if (isToday(d)) return format(d, "'Hoje' HH:mm", { locale: ptBR });
    return format(d, "dd/MM HH:mm", { locale: ptBR });
  } catch {
    return prazo;
  }
}

export function isPrazoAtrasado(tarefa: Pick<Tarefa, "prazo" | "status">): boolean {
  if (!tarefa.prazo) return false;
  if (tarefa.status === "concluida" || tarefa.status === "cancelada") return false;
  try {
    return isBefore(parseISO(tarefa.prazo), startOfDay(new Date()));
  } catch {
    return false;
  }
}

export function iniciais(nome: string | null | undefined): string {
  if (!nome?.trim()) return "?";
  const parts = nome.trim().split(/\s+/);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

/** datetime-local value from ISO */
export function toDatetimeLocal(iso: string | null | undefined): string {
  if (!iso) return "";
  try {
    const d = parseISO(iso);
    return format(d, "yyyy-MM-dd'T'HH:mm");
  } catch {
    return "";
  }
}

/** ISO from datetime-local */
export function fromDatetimeLocal(value: string): string | null {
  if (!value) return null;
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return null;
  return d.toISOString();
}
